import { cn } from '../presets/utils';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

export type ModalDialogProps = React.ComponentProps<typeof Dialog> & {
  title?: string;
  description?: string;
  className?: string;
  /**
   * Classes for the scrollable BODY. `className` only reaches
   * DialogContent, so a consumer with a tall form could not lift the
   * default `max-h-[70vh]` and its fields stayed behind an inner
   * scrollbar even on a large screen. Pass e.g. `max-h-[80vh]`.
   */
  bodyClassName?: string;
  footer?: React.ReactNode;
};

export const ModalDialog = ({
  title,
  description,
  footer,
  className,
  bodyClassName,
  ...props
}: ModalDialogProps) => {
  return (
    <Dialog {...props}>
      <DialogContent
        className={cn('sm:max-w-2xl max-h-[90vh] flex flex-col p-0', className)}
      >
        <DialogHeader className="flex-shrink-0 p-6 pb-0 text-start">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div
          className={cn(
            'flex-1 overflow-y-auto px-4 pb-4 max-h-[70vh]',
            bodyClassName
          )}
        >
          {props.children}
        </div>
        {footer && (
          <DialogFooter className="flex-shrink-0 p-6 pt-0">
            <div className="w-full">{footer}</div>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ModalDialog;
